// SubSectorList.jsx
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { fetchSectorById } from '../../../store/sectorSlice';
import CommonModal from 'components/common/modal/DynamicModal';
import '../../../assets/scss/cmn.scss'
import { BsPersonWorkspace } from "react-icons/bs";
import DynamicBreadcrumbs from 'components/breadcrumbs/dynamicbreadcrumbs';
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"
import { MdOutlineDeleteOutline } from "react-icons/md";

import VerticalFilterBar from 'components/filter/verticalfilter';
import { fetchIndicators, fetchIndicatorById, clearIndicators, clearSectorIndicators } from '../../../store/filterSlice';
import { Button } from 'react-bootstrap';
import { FaRegUserCircle } from "react-icons/fa";
import IndicatorsList from "../Indicator/Indicator"
import { addIndicator, setWorkspaceLoaded, startNewWorkspace } from "store/workspaceSlice";
import { removeIndicator } from "store/workspaceSlice";
import { toast } from 'react-toastify';
import Cmn_Workspace from 'components/cmn_workspace/cmn_workspace';
import CustomToast from 'components/toast/customToast';
import SaveWorkspaceModal from 'components/authentication/signup-login/SaveWorkspaceModal';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import { useAutoLoadDefaultWorkspace } from 'components/authentication/signup-login/useAutoLoadDefaultWorkspace';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SubSectorList = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const sectors = location.state?.sector;
  const subsector = location.state?.subsector;
  const { selectedSector: sector, loading } = useSelector((state) => state.sector);

  const [activeSubsectorId, setActiveSubsectorId] = useState(null);
  // const [selectedIndicators, setSelectedIndicators] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedDatasetOption, setSelectedDatasetOption] = useState(null);
  const [selectedTimeOption, setSelectedTimeOption] = useState(null);
  const [show, setShowModal] = useState(false);
  const [showWorkspace, setShowWorkspace] = useState(true);
  const [selectedModalIndicator, setSelectedModalIndicator] = useState(null);
  const sectorData = useSelector((state) => state.sector);
  const filteredSupertags = sectors?.supertags?.filter(sub => sub.name !== 'NA');
  const [indicatorData, setIndicatorData] = useState([]);
  const [indicatorFilterData, setFilterIndicatorData] = useState([]);
  const [filterMetaData, setMetaData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);

  const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures || []);
  const isWorkspaceLoaded = useSelector(state => state.workspace.isWorkspaceLoaded);
  const loadedWorkspaceName = useSelector(state => state.workspace.loadedWorkspaceName);
  const hasUnsavedChanges = useSelector(state => state.workspace.hasUnsavedChanges);
  const currentWorkspace = useSelector(state => state.workspace.currentWorkspace);

  const { isAuthenticated, login } = useAuth();
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingSaveMode, setPendingSaveMode] = useState(null);
  const [modalMode, setModalMode] = useState('save');

  // derive a simple localSelectedLocations list to pass into SaveWorkspaceModal
  const localSelectedLocations = Array.isArray(selectedMapFeatures) && selectedMapFeatures.length > 0
    ? selectedMapFeatures.map(f => ({
        value: f.properties?.code ?? f.id ?? null,
        label: f.name ?? f.properties?.name ?? '',
        geo_level: f.geo_level ?? f.properties?.geo_level_code ?? null,
      }))
    : [];

  useAutoLoadDefaultWorkspace();

  useEffect(() => {
    if (id) dispatch(fetchSectorById(id));
  }, [id, dispatch]);

  const getSector = sectorData?.sectors || sectors;
  useEffect(() => {
    let called = false;
    dispatch(clearIndicators());
    dispatch(clearSectorIndicators());
    if (id && !called) {
      called = true;
      dispatch(fetchIndicatorById(id))
        .unwrap()
        .then((data) => {
          setIndicatorData(Array.isArray(data.indicators) ? data.indicators : []);
          setMetaData(data.filter_metadata)
        })
        .catch((err) => {
          console.error("API error:", err);
          setIndicatorData([]);
        });
    }
    return () => { called = true; };
  }, [id, dispatch]);

  useEffect(() => {
    if (sector?.subsectors?.length && !activeSubsectorId) {
      const defaultSub = sector.subsectors.find((sub) =>
        sub.title?.toLowerCase().includes('population')
      );
      setActiveSubsectorId(defaultSub?.id || sector.subsectors[0]?.id);
    }
  }, [sector, activeSubsectorId]);
  const visualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators } })
  }
  const handleIndicatorSelect = (indicator) => {
    toast(<CustomToast message={`${indicator.indicator_name} added to workspace`} type="success" />, { position: "top-right" });

    dispatch(addIndicator(indicator));
  };

  const subSectorList = (SubsectorList) => {
    navigate(`/sector/sub-subsector/${SubsectorList.code}`, {
      state: {
        sector: sectors,
        subsector: subsector,
        subsubsector: SubsectorList,
      },
    });
  };

  const onFilterApplyHandler = (filteredData) => {
    setIsFilterApplied(true);
    setFilterIndicatorData(Array.isArray(filteredData) ? filteredData : []);
  };

  const clearFilters = () => {
    setIsFilterApplied(false);
    setFilterIndicatorData([]);
  };
  const sortFilters = () => {

  }

  // Workspace management functions
  const handleSaveClick = (mode = 'save') => {
    if (!isAuthenticated) {
        setPendingSaveMode(mode);
        setShowAuthModal(true);
        return;
    }
    
    if (selectedIndicators.length === 0) {
        return;
    }
    
    setModalMode(mode);
    setShowSaveModal(true);
  };

  const handleLoginSuccess = (response) => {
    console.log('Login successful in SubSectorList:', response);
    
    const loginData = response.data || response;
    let userData = null;
    let token = null;
    
    if (loginData && loginData.user) {
        userData = loginData.user;
        token = loginData.token;
    } else {
        userData = {
            name: response.name || response.user?.name || 'User',
            email: response.email || response.user?.email || 'user@example.com'
        };
        token = response.token || response.access_token;
    }
    
    login(userData, token);
    setShowAuthModal(false);
    
    if (pendingSaveMode) {
        setTimeout(() => {
            // Double-check authentication before opening save modal
            const token = localStorage.getItem('authToken');
            const userData = localStorage.getItem('userData');
            
            if (token && userData) {
                setModalMode(pendingSaveMode);
                setShowSaveModal(true);
            } else {
                // If still not authenticated, show error
            }
            setPendingSaveMode(null);
        }, 1000); // Increased delay to ensure auth state is fully updated
    }
  };

  const handleSaveSuccess = (workspaceData) => {
    // Always load the saved workspace as current (for both new saves and save as)
    if (workspaceData.id && workspaceData.name) {
      console.log('Loading saved workspace:', workspaceData.name, 'ID:', workspaceData.id);
      // Add a small delay to ensure the workspace is properly created
      setTimeout(() => {
        // Dispatch action to load the workspace
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
        console.log('Workspace loaded with name:', workspaceData.name);
      }, 100);
    }
    
    setShowSaveModal(false);
  };

  const handleNewWorkspace = () => {
    // Clear all indicators and locations and reset to "My Workspace" state
    dispatch(startNewWorkspace());
  };
  const baseData = isFilterApplied
    ? (Array.isArray(indicatorFilterData) ? indicatorFilterData : [])
    : (Array.isArray(indicatorData) ? indicatorData : []);

  const search = searchTerm?.trim().toLowerCase() || "";
  const filteredIndicators = search
    ? baseData.filter((ind) => (ind.indicator_name || "").toLowerCase().includes(search))
    : baseData;

  if (loading) return <div className="p-4">Loading...</div>;
  if (!sector) return <div className="p-4">Sector not found</div>;

  return (
    <>
      <button className="btn  d-flex align-items-center ui-wp rotated-btn" style={{ backgroundColor: '#a3cefa' }} onClick={() => setShowWorkspace(!showWorkspace)}>
        <BsPersonWorkspace size={20} className="me-1 " />
        Workspace
      </button>
      <div className="container-fluid bg-white py-4">
        <div className="row">
          <div className={` ${!showWorkspace ? 'col-md-9' : 'col-md-12'}`}>
            <DynamicBreadcrumbs />
            <div className="mb-4 ui-sectors-cards">
              <h4 className="text-warning mb-2">{subsector?.name || sectorData.sectors.name}</h4>
              <p className='color-dark-blue'>{subsector?.description || sectorData.sectors?.description}</p>
              <div className="d-flex flex-wrap gap-2 mb-2">
                {sector?.supertags?.map((sub) => (
                  <button
                    key={sub.code}
                    className={`btn ${activeSubsectorId === sub.code ? 'btn-primary btn-sm' : 'btn-outline-primary btn-sm'}`}
                    onClick={() => {
                      subSectorList(sub);
                      setSearchTerm('');
                    }}
                    style={{ display: sub.name === 'NA' ? 'none' : 'inline-block' }}
                  >
                    {sub.name}
                  </button>
                ))}
              </div>
            </div>

            {/* dya */}
            <IndicatorsList
              indicatorData={indicatorData}
              filterMetaData={filterMetaData}
              onIndicatorSelect={handleIndicatorSelect}
              selectedIndicators={selectedIndicators}
              onFilterApply={onFilterApplyHandler}
            />
          </div>

          {!showWorkspace && (
            <div className="position-fixed workspace-scroll  end-0 bg-white shadow"
              style={{
                top: '68px',
                width: '420px',
                height: '100vh',
                zIndex: 1050,
                overflowY: 'scroll',
                // overflowY: 'auto',
                msOverflowStyle: "none", // IE/Edge
                scrollbarWidth: "none",  // Firefox
                padding: '0',
                borderLeft: '1px solid #ddd',

              }}>
              <div className=" h-100 border-0">
                <div className="card-header ui-card-header d-flex justify-content-between align-items-center  border-0 ">
                  <h5 className="mb-0">
                    <FaRegUserCircle /> &nbsp;
                    {isWorkspaceLoaded ? loadedWorkspaceName : 'My Workspace'}
                    {hasUnsavedChanges && <span className="text-warning ms-2">*</span>}&nbsp;
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="filter-tooltip">
                          <p>Click save to access your work later.</p>
                        </Tooltip>
                      }
                    >
                      <span>
                        <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                      </span>
                    </OverlayTrigger>
                  </h5>
                  <button className="btn btn-sm btn-outline-dark" onClick={() => setShowWorkspace(true)}>
                    <MdOutlineKeyboardDoubleArrowRight />
                  </button>
                </div>
                <div className="card-body pt-3 p-2">
                  <div className='row'>
                    <div className='col-md-4'><h5 className='f-14 fw-bold'>Indicators</h5></div>
                    <div className='col-md-8'>
                      <div className='d-flex ui-up'>
                        <div className='p-1'>
                          <Button 
                            variant="primary"
                            className='f-14 btn-sm' 
                            onClick={() => handleSaveClick(isWorkspaceLoaded ? 'update' : 'save')}
                          >
                            <i className={`bi ${isWorkspaceLoaded ? 'bi-arrow-repeat' : 'bi-save'} me-1`}></i>
                            {isWorkspaceLoaded ? 'Update' : 'Save'}
                          </Button>
                        </div>
                        <div className='p-1'>
                          <Button variant="outline-primary" className='btn-sm f-14' onClick={() => handleSaveClick('saveAs')}>
                            Save As
                          </Button>
                        </div>
                        <div className='p-1'>
                          <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={handleNewWorkspace}
                          >
                            <i className="bi bi-plus-circle me-1"></i> New
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Cmn_Workspace visualize={(inds) => {visualize(inds)} }
                showWorkspace={showWorkspace} 
        setShowWorkspace={setShowWorkspace}/>

                </div>
              </div>
            </div>
          )}

          <CommonModal
            isOpen={show}
            onClose={() => setShowModal(false)}
            title="Modal Title"
            footer={
              <>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary">Save changes</button>
              </>
            }
          >
            <p>This is a dynamic modal body</p>
          </CommonModal>
        </div>
      </div>

      <SaveWorkspaceModal
        show={showSaveModal}
        handleClose={() => setShowSaveModal(false)}
        onSave={handleSaveSuccess}
        selectedIndicators={selectedIndicators}
        selectedLocations={localSelectedLocations} 
        allMapFeatures={selectedMapFeatures}
        mode={modalMode}
      />
      <AuthModalHandler
        show={showAuthModal}
        handleClose={() => {
          setShowAuthModal(false);
          setPendingSaveMode(null);
        }}
        initialMode="login"
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
};

export default SubSectorList;
